import(/* webpackMode: "eager" */ "/home/ubuntu/download/699eeee8f782d50014882d33/baninvest/src/app/not-found.tsx");
